export default {"src":"/_next/static/media/deco_hosted_sheen.f18fe4e9.svg","height":65,"width":122,"blurWidth":0,"blurHeight":0};